<template>
  <div>
    <menu-top/>


    <v-main>
      <div id="calculadora-matriculacion">
        <section>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="10">
                <h1 class="mt-10 mb-3">Calcular l'impost de matriculació (model 576)</h1>
                <p class="mb-8 intro-iedmt">
                  Si portes un cotxe d'Alemanya, França o qualsevol altre país de la Unió
                  Europea, abans de matricular-lo a Espanya hauràs de liquidar l'Impost
                  Especial sobre Determinats Mitjans de Transport. Calcula aquí quant et
                  costarà: Hisenda no parteix del preu que has pagat, sinó del valor fiscal
                  del BOE ajustat per l'antiguitat del vehicle i per les seves emissions de
                  CO2. A Gestoria Riola confirmem el valor, presentem el model 576 i
                  tramitem la matriculació completa per tu.
                </p>

                <calculadora-matriculacion
                  :formspree-endpoint="'https://formspree.io/f/mlgqpqkw'"
                  idioma="cat"
                />
              </v-col>
            </v-row>
          </v-container>
        </section>

        <Footer/>
      </div>
    </v-main>

    <menu-bottom/>
  </div>
</template>

<script>
  import MenuTop from "@/components/MenuTopCat";
  import MenuBottom from "@/components/MenuBottomCat";
  import { mapGetters } from 'vuex';

  import Footer from "@/components/FooterCat";
  import CalculadoraMatriculacion from "@/components/CalculadoraMatriculacion";

  export default {
    name: 'PageCalculadoraMatriculacionCat',
    data: () => ({
    }),
    computed: {
      ...mapGetters(['collapseSidebar']),
    },
    methods: {
    },
    components: {
      Footer,
      MenuTop,
      MenuBottom,
      CalculadoraMatriculacion
    }
  }
</script>

<style scoped>
  .intro-iedmt {
    color: #37454A;
    max-width: 760px;
  }
  #calculadora-matriculacion h1 {
    color: #900A30;
  }
</style>
